<template>
<!-- <div v-show="true"> -->
<v-stepper v-model="e1">
    <!-- header section -->
    <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" color="#A6C307" step="1">{{ $t("message.payment_methods") }}</v-stepper-step>
         <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" color="#A6C307" step="2">{{ $t("message.payment_info") }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step  color="#A6C307" v-if="seen" step="3">{{ $t("message.creditcard") }}</v-stepper-step>
    </v-stepper-header>
    <!-- content section -->
    <v-stepper-items>
         <v-stepper-content step="1">
            <app-payment-method-form @submit="submit"/>
            <!-- buttons -->
             <v-flex class="text-xs-center">
                 <i class="fa fa-lock" aria-hidden="true"></i> 100% SECURE PAYMENT BY:
            </v-flex>
            <v-flex class="text-xs-center">
                <img src="https://repository.mundoinspira.com/payment/LogosCredit/Visa.png">
                <img src="https://repository.mundoinspira.com/payment/LogosCredit/Mastercard.png">
                <img src="https://repository.mundoinspira.com/payment/LogosCredit/American.png">
                <img src="https://repository.mundoinspira.com/payment/LogosCredit/discover.png">
            </v-flex>
            <v-flex class="text-xs-center">
                <v-btn color="primary" :disabled="pending" :loading="pending" @click="next('form0')">
                    {{ $t("message.continue") }}
                </v-btn>
            </v-flex>
        </v-stepper-content>
        <v-stepper-content step="2">
            <app-payment-info-form @submit="submit" :valueinfo="data_paydefault" :valueExpire="expire" :valueCreditCard="creditCard" :valueItemPay="itemPayment"/>
            <!-- buttons -->
             <v-flex class="text-xs-center">
                <v-btn color="info" :disabled="pending"  @click="back">{{ $t("message.back") }}</v-btn>
            
                 <template v-if="pay && creditCard != null" >
                    <v-btn color="primary" :disabled="pending" :loading="pending" @click="next('form_default')">
                        {{button_name}}
                    </v-btn>
                </template>
                <v-btn color="primary" v-show="seen" @click="next('form1')">
                    {{ $t("message.continue") }}
                </v-btn>
            </v-flex>
        </v-stepper-content>
        <v-stepper-content step="3" v-if="seen">
            <app-credit-card-form @submit="submit" />
            <v-flex class="text-xs-center">
                <!-- buttons -->
                <v-btn color="info" :disabled="pending" @click="back">{{ $t("message.back") }}</v-btn>
                <!-- submit button -->
                <template v-if="pay">
                    <v-btn color="primary" :disabled="pending" :loading="pending" @click="next('form2')">
                        {{button_name}}
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn color="success">
                        <v-icon dark >done</v-icon>
                    </v-btn>
                </template>
            </v-flex>
        </v-stepper-content>
    </v-stepper-items>
</v-stepper>
<!-- </div> -->
</template>
<script>
import { EventBus } from './EventBus.js';
import PaymentMethod from './PaymentMethod.vue'
import PaymentInfoForm from './PaymentInfoForm.vue'
import CreditCardForm from './CreditCardForm.vue'
import axios from 'axios'

export default {
    components: {
        'app-payment-method-form': PaymentMethod,
        'app-payment-info-form': PaymentInfoForm,
        'app-credit-card-form': CreditCardForm,
    },
    props: {
        pending: { type: Boolean, default: false },
        pay: { type: Boolean, default: true },
        button_name: { type: String, default: '' },
        step: { type: Number, default: 0 },
    },
    data() {
        return {
            seen: true,
            e1: 0,
            isConnected: false,
            isValid: false,
            data_paydefault:{paymentMethod:"card"},
            returnPaymentMethod:'',
            expire:"",
            creditCard:null,
            itemPayment:null,
        }
    },
    mounted() {
        EventBus.$on('e1', this.resetStep);
        EventBus.$on('another', this.another);
        EventBus.$on('nextStep', this.nextStep);
        EventBus.$on('stepperView', this.stepperView);
        EventBus.$on('generarRecibo', this.generarRecibo);

    },
    watch: {
        e1(val) {
            if(val === 2) {
                EventBus.$emit('focus');
            }
        }
    },
    methods: {
        submit(data) {
            if(data.form === 'form2') {
                this.$emit('creditCardData', data);
            } else if(data.form === 'form1') {
                let _this = this;
                axios.post(process.env.VUE_APP_PROVIDER, {
                            name: data.billing_address.country
                        } , {
                            headers: { 'Content-Type': 'application/json', }
                        }
                    )
                    .then(response => {
                        if(response.data.cod == 'SUCCESS') {
                            _this.$emit('paymentInfoData', data, response.data.provider);
                        } else {
                            console.log('not supported country');
                        }

                    })
                    .catch(error => {
                        console.log('not supported country');
                    });
             }else if(data.form === 'form0') {
                   if(data.paydefault !="card"){
                        if(this.returnPaymentMethod =='CASH'){
                            this.nextStep();
                        }else if(this.creditCard != null){
                              this.nextStep();
                              this.$emit('paymentProvider',data.provider);

                        }else{
                            this.$emit('createSource',data.paydefault,data.provider,this.expire);
                        }
                   }else{
                       console.log("form0 >>>> nextStep");
                       this.nextStep();
                   }
                  
            }else if(data.form === 'form_default'){
                this.$emit('creditCardData_save',data);
            }
        },
        next(scope) {
            console.log("Emite un next stepper");
            EventBus.$emit('next', scope);
        },
        back() {
            console.log('back >>'+this.e1);
            this.e1--;
        },
        nextStep() {
            console.log('nextStep >>'+this.e1);
            this.e1++;
        },
        resetStep() {
            this.e1 = 1;
            EventBus.$emit('resetForm0');
            EventBus.$emit('resetForm1');
            EventBus.$emit('resetForm2');
            EventBus.$emit('resetform_default');
        },
        stepperView(radio){
            this.returnPaymentMethod = radio.returnPaymentMethod;
            var regex = /[A-Z]/gi;
            var hours = radio.expire.replace(regex, '');
           
            this.creditCard = radio.creditCard;
           
            this.expire = hours;
            this.itemPayment = radio.item;
            this
            this.data_paydefault = radio; 
            if(radio.paymentMethod ==='card'){
                this.seen = true;
            }else{
                 this.seen = false;
            }
        },
        generarRecibo(jsonPay) {

            this.$emit('createSource',jsonPay.method,jsonPay.provider,jsonPay.expire,jsonPay.return_payment);
          
        },
    },
}
</script>
